import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/button';

/**
 * Friendly terminal state for a trip/journey the current account cannot open
 * (deleted, or owned by someone else — the API deliberately returns the same
 * 404 for both, so the copy covers both without claiming to know which).
 * Replaces the old bare "not found" line + error toast pair (Paulo
 * 2026-09-11): the page states what happened, points at the share-link path
 * for the "someone sent me their trip URL" case, and offers a way onward.
 * Rendered by TripDetailPage and JourneyDetailPage on a 404 initial load.
 */
const NotAvailableCard: React.FC<{
  kind: 'trip' | 'journey';
  /** Guests go to the Jody home instead of My Trips. */
  isGuest?: boolean;
}> = ({ kind, isGuest }) => {
  const navigate = useNavigate();
  const thing = kind === 'trip' ? 'trip' : 'journey';
  return (
    <div style={{ maxWidth: 440, margin: '32px auto 0' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: '28px 24px', textAlign: 'center', boxShadow: '0 1px 3px rgba(20,40,30,0.10)' }}>
        <h1 style={{ fontFamily: 'Fraunces, Georgia, serif', fontSize: 22, fontWeight: 600, color: '#16241d', margin: '0 0 10px' }}>
          This {thing} isn't available
        </h1>
        <p style={{ fontSize: 14, color: '#6c7872', lineHeight: 1.6, margin: '0 0 8px' }}>
          It may have been deleted, or it may belong to a different account.
        </p>
        <p style={{ fontSize: 14, color: '#6c7872', lineHeight: 1.6, margin: '0 0 18px' }}>
          If someone wants to show you their trip, ask them to send you their
          share link. Share links open for anyone.
        </p>
        <Button type="button" onClick={() => navigate(isGuest ? '/' : '/trips')}>
          {isGuest ? 'Back to Jody' : 'Go to My Trips'}
        </Button>
      </div>
    </div>
  );
};

export default NotAvailableCard;
